/**
 * Import depedencies
 */

import { combineReducers } from 'redux';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

/**
 * Import reducers
 */

import { connectRouter } from 'connected-react-router';
import { reducer as notificationsReducer } from 'reapop';

import authenticationReducer from './authentication';
import blockReducer from './block';
import schoolReducer from './school';
import ambassadorReducer from './ambassador';
import jobReducer from './job';
import trainingReducer from './training';
import pageReducer from './page';
import newsReducer from './news';
import eventsReducer from './events';
import groupReducer from './group';

/**
 * List all reducers
 */

const authenticationPersistConfig = {
    key: 'authentication',
    storage: localForage,
    whitelist: ['user', 'token'],
};

const blockPersistConfig = {
    key: 'block',
    storage: localForage,
};

const schoolPersistConfig = {
    key: 'school',
    storage: localForage,
};

const ambassadorPersistConfig = {
    key: 'ambassador',
    storage: localForage,
};

const jobPersistConfig = {
    key: 'job',
    storage: localForage,
};

const trainingPersistConfig = {
    key: 'training',
    storage: localForage,
};

const newsPersistConfig = {
    key: 'news',
    storage: localForage,
};

const eventsPersistConfig = {
    key: 'events',
    storage: localForage,
};

const pagePersistConfig = {
    key: 'page',
    storage: localForage,
};

const groupPersistConfig = {
    key: 'group',
    storage: localForage,
};

export default (history) =>
    combineReducers({
        router: connectRouter(history),
        notifications: notificationsReducer(),
        authentication: persistReducer(
            authenticationPersistConfig,
            authenticationReducer
        ),
        block: persistReducer(blockPersistConfig, blockReducer),
        school: persistReducer(schoolPersistConfig, schoolReducer),
        job: persistReducer(jobPersistConfig, jobReducer),
        ambassador: persistReducer(ambassadorPersistConfig, ambassadorReducer),
        training: persistReducer(trainingPersistConfig, trainingReducer),
        page: persistReducer(pagePersistConfig, pageReducer),
        news: persistReducer(newsPersistConfig, newsReducer),
        events: persistReducer(eventsPersistConfig, eventsReducer),
        group: persistReducer(groupPersistConfig, groupReducer),
    });
